// removed by extract-text-webpack-plugin
module.exports = {"avatar":"_1fgWprz8aUeKciq9LLskWR","fluid":"_5elZJZL8lXl2I95Jkbz22","editable":"_24j9TrQFLviq01ny7YP4EX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Avatar/avatar.scss
// module id = 527
// module chunks = 0